import ProductPaymentCart from "./ProductPaymentCart";
import {
  createAction,
  createEntityAdapter,
  createReducer,
  createSelector,
  EntityState,
} from "@reduxjs/toolkit";

import { RootState } from "store";
import Goods from "store/productPayment/goods/Goods";

export const addCart = createAction<Goods>("productPayment/addCart");

export const removeCart = createAction<{ productTID: string }>(
  "productPayment/removeCart"
);
export const restoreCart = createAction<Array<ProductPaymentCart>>(
  "productPayment/restoreCart"
);

export const clearCart = createAction("productPayment/clearCart");

export const setInstallmentAmount = createAction<number | null>(
  "productPayment/setInstallmentAmount"
);

const cartEntities = createEntityAdapter<ProductPaymentCart>({
  selectId: (item) => item.productTID,
});

export interface CartState extends EntityState<ProductPaymentCart> {
  installmentAmount: number | null;
}

const initialState: CartState = cartEntities.getInitialState({
  installmentAmount: null,
});

export const cartReducer = createReducer(initialState, (builder) => {
  builder.addCase(addCart, (state, action) => {
    const { productTID } = action.payload;
    const cartProduct = state.entities[productTID];
    if (cartProduct) {
      const qty = cartProduct.saleQty + 1;
      cartProduct.saleQty = qty;
      cartProduct.saleAmt = cartProduct.productAmt * qty;
    } else {
      cartEntities.addOne(state, { ...action.payload, saleQty: 1, productAmt: action.payload.saleAmt });
    }
  });
  builder.addCase(removeCart, (state, action) => {
    const { productTID } = action.payload;
    const cartProduct = state.entities[productTID];
    if (cartProduct) {
      if (cartProduct.saleQty === 1) {
        cartEntities.removeOne(state, productTID);
      } else {
        const qty = cartProduct.saleQty - 1;
        cartProduct.saleQty = qty;
        cartProduct.saleAmt = cartProduct.productAmt * qty;
      }
    }
  });
  builder.addCase(clearCart, (state) => {
    return initialState;
  });
  builder.addCase(restoreCart, (state, action) => {
    cartEntities.addMany(state, action.payload);
  });
  builder.addCase(setInstallmentAmount, (state, action) => {
    state.installmentAmount = action.payload;
  });
});

export const getCartState = (state: RootState): CartState =>
  state.productPayment.cart;
export const getEntities = (state: RootState) => getCartState(state).entities;
export const getCartList = (state: RootState): ProductPaymentCart[] =>
  Object.values(getEntities(state)) as ProductPaymentCart[];
export const getCartItemById = (state: RootState, props: { id: string }) =>
  getEntities(state)[props.id];
export const getCartTotalCount = createSelector(getCartList, (list): number => {
  return list
    .map((item) => item.saleQty)
    .reduce((sum, current) => sum + current, 0);
});
export const getInstallmentAmount = (state: RootState) =>
  getCartState(state).installmentAmount;
